import styled from "styled-components";

const AboutTextWrap = styled.div`
  max-width: 800px;
  margin: 30px auto;
  padding: 40px max(10%, 20px);
  background-color: #7e42e5c2;
  color: white;
`;

export { AboutTextWrap };
